import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import CreaServicios from "../Modals/crear/CreaServicios";

import Cookies from "universal-cookie";
import {
  obtenerServiciosModalidad,
  obtenerServiciosModalidadPorInstitucion,
} from "../../Services/Rest";
import CreaServiciosModalidad from "../Modals/crear/CreaServiciosModalidad";

const urlA = obtenerServiciosModalidad;
const urlU = obtenerServiciosModalidadPorInstitucion;
const cookie = new Cookies();

if (cookie.get("tipo_Usuario") == 1) {
  var urlendpoint = urlA;
}
if (cookie.get("tipo_Usuario") == 2) {
  var urlendpoint = urlU + cookie.get("institucionid");
}
if (cookie.get("tipo_Usuario") == 3) {
  var urlendpoint = urlU + cookie.get("institucionid");
}
if (cookie.get("tipo_Usuario") == 4) var urlendpoint = urlA;

function InfoServiciosModalidad(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const [postEstado, setPostEstado] = useState([]);
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerInstituciones",
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  const BusacarPorEstado = () => {
    axios
      .get(obtenerServiciosModalidadPorInstitucion + postEstado)
      .then((response) => {
        setList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlecountry = (event) => {
    const EStadoId = event.target.value;
    setPostEstado(EStadoId);
  };
  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Informacion Servicios{" "}
                </h6>
              </div>
              <div class="card-body">
                {cookie.get("tipo_Usuario") == 1 ? (
                  <form>
                    <select
                      className="btn btn-secondary btn-user btn-block text-left"
                      onChange={(e) => handlecountry(e)}
                    >
                      <option value="0">Seleccione </option>

                      {list1.map((getcon, index) => (
                        <option key={index} value={getcon.id}>
                          {getcon.razon_Social}{" "}
                        </option>
                      ))}
                    </select>

                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={() => BusacarPorEstado()}
                    >
                      buscar
                    </button>
                    <hr />
                  </form>
                ) : (
                  <h1></h1>
                )}
                <CreaServiciosModalidad />{" "}
                <a href="../../formatos/FormatoServicioModalidad.csv" download>
                  Descargar Formato
                </a>
                <hr />
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Sede</th>
                        <th>Grupo del Servicio</th>
                        <th>Modalidad</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.id}</td>
                            <td>{item.sede}</td>
                            <td>{item.grupoServicio}</td>
                            <td>{item.modalidad}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default InfoServiciosModalidad;
